namespace ui
{
	export namespace Form
	{
		export class SearchInput
			extends Input
		{

			public constructor( value: string, descriptor: IBasicInputDescriptor )
			{
				super( value, descriptor, 'search', InputValueTypes.STRING );
			}

			public value( val: string|null ): SearchInput
			{
				return super.value( val ) as SearchInput;
			}

			public val(): string|null
			{
				return this.m_Root.val() as string || null;
			}

		}

	}
}
